.backdrop {
  background: rgba(255, 255, 255, 0.6);
}
